module.exports = __webpack_public_path__ + "static/avatar-155b76b8aaa188b0e9fd684aad111418.jpg";